// src/pages/Reports/CurrentAssetLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import CurrentAssetLedgerFilters from "./components/CurrentAssetLedgerFilters";
import CurrentAssetLedgerTable from "./components/CurrentAssetLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const CurrentAssetLedger = () => {
  const { filters } = useSelector((state) => state.currentAssetLedger);
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Current Asset Balance Ledger",
    removeAfterPrint: true,
  });
  const handleNavigateToBack = () => {
    navigate("/reports");
  };

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={handleNavigateToBack}
              style={{ marginRight: 8 }}
            />
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Current Asset Balance Ledger</Title> </div>}
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CurrentAssetLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CurrentAssetLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Current Asset Balance Ledger"
          mode="report-page"
          filters={filters}
          renderTable={() => <CurrentAssetLedgerTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default CurrentAssetLedger;
